module.exports = __webpack_public_path__ + "assets/fonts/office-file-pdf-1.9b0a58aa.svg";